import type { CurrentOfficeType } from "shared/types/user";

export const REASON_DESCRIPTION_MAX_LENGTH = 200;
export const REPORT_REASON_SCAM = 1;
export const REPORT_REASON_HARASSMENT = 2;
export const REPORT_REASON_FAKE_ACCOUNT = 3;
export const REPORT_REASON_INAPPROPRIATE = 4;
export const REPORT_REASON_OTHER = 5;
export const USER_VIP_SUPPORT_ENABLED = 1;
export const USER_VIP_SUPPORT_DISABLED = 0;
export const REAL_PRESENTS_ENABLED = 1;

export const ABUSE_REASONS = {
  [REPORT_REASON_SCAM]: "scam",
  [REPORT_REASON_HARASSMENT]: "harassment",
  [REPORT_REASON_FAKE_ACCOUNT]: "fakeAccount",
  [REPORT_REASON_INAPPROPRIATE]: "inappropriate",
  [REPORT_REASON_OTHER]: "other",
};

export const ABUSE_REASON_SPAM = 1;
export const ABUSE_REASON_VIOLENCE = 2;
export const ABUSE_REASON_IMPRESONATION = 3;
export const ABUSE_REASON_CHILD = 4;
export const ABUSE_REASON_INAPPROPRIATE = 5;
export const ABUSE_REASON_NUDITY = 6;
export const ABUSE_REASON_FRAUD_SCAM = 7;
export const ABUSE_REASON_HATE_SPEECH = 8;
export const ABUSE_REASON_ILLEGAL_ACTIVITY = 9;
export const ABUSE_REASON_UNDERAGE_USER = 10;
export const ABUSE_REASON_HARASSMENT = 11;
export const ABUSE_REASON_OTHER = 12;

export const ABUSE_DESCRIPTION_MIN_LENGTH = 20;
export const ABUSE_DESCRIPTION_MAX_LENGTH = 500;

export const EXTENDED_ABUSE_REASONS = {
  [ABUSE_REASON_SPAM]: "spam",
  [ABUSE_REASON_VIOLENCE]: "violence",
  [ABUSE_REASON_IMPRESONATION]: "impersonation",
  [ABUSE_REASON_CHILD]: "childSafetyConcerns",
  [ABUSE_REASON_INAPPROPRIATE]: "inappropriateMedia",
  [ABUSE_REASON_NUDITY]: "nudity",
  [ABUSE_REASON_FRAUD_SCAM]: "fraud",
  [ABUSE_REASON_HATE_SPEECH]: "hateSpeech",
  [ABUSE_REASON_ILLEGAL_ACTIVITY]: "illegalActivity",
  [ABUSE_REASON_UNDERAGE_USER]: "underageUser",
  [ABUSE_REASON_HARASSMENT]: "harassment",
  [ABUSE_REASON_OTHER]: "other",
};

export const BILLING_TYPE_CHAT_PER_MINUTE = 1;

export const APP_VERSION_V2 = 2;

export const defaultCurrentOffice: CurrentOfficeType = {
  campaign: "Devurum Limited",
  country: "Cyprus",
  city: "Limassol",
  address: "8 Amathountos ave, off 201, 4531",
  state: null,
  index: null,
  regNumber: "HE 368090",
  phone: import.meta.env.VITE_APP_CELL_PHONE,
  email: import.meta.env.VITE_APP_MULTI_SITE_SUPPORT_EMAIL,
};
